<template>
    <div :style="style" class="main">
        <center-content></center-content>
    </div>
</template>

<script>
    import CenterContent from '@/pages/Center/index'

    export default {
        name: "Main",
        data() {
            return {
                showType: '',
                style: {
                    'width': '1919px',
                    'height': '1079px',
                    'overflow': 'hidden',
                    'background-color': '#100449'
                },
            }
        },
        created() {
        },
        methods: {},
        components: {
            "center-content": CenterContent
        },
    }
</script>

<style scoped lang="scss">
    .main {
        user-select: none;
        position: relative;
        background-image: url("../assets/img/bg@2x.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
    }
</style>
